<template>
    <input
        class="h:48 r:8 p:13.5|16 w:100% b:1|solid|gray300 f:gray800 outline:none font-md bg:white {f:gray400}::placeholder {b:1|solid|y500}:focus bg:gray100[disabled]"
        :id="id"
        @input="$emit('update:modelValue', $event.target.value)"
        :value="modelValue"
    />
</template>

<script setup>
    const props = defineProps({
        id: { default: () => nextId(), type: String },
        modelValue: { type: String },
        rules: { default: {}, type: Object }
    });

    let validator;

    const apply = (target) => {
        const rules = Object.keys(props.rules).map((rule) => {
            const errorMessage = props.rules[rule];

            return typeof errorMessage === "object" ? { rule, ...errorMessage } : { rule, errorMessage };
        });

        validator = target;
        validator.addField(`#${props.id}`, rules);
    };

    const show = (message) => validator.showErrors({ [`#${props.id}`]: message });

    defineExpose({ apply, show });
</script>
